export const fr_FR = {
  languageType: "fr_FR",
  Settings_Language: "Langue",
  Tab_Shop: "Shop",
}